import { render } from "./PtCookie.vue?vue&type=template&id=0eafbcc4&scoped=true&ts=true"
import script from "./PtCookie.vue?vue&type=script&lang=ts"
export * from "./PtCookie.vue?vue&type=script&lang=ts"

import "./PtCookie.vue?vue&type=style&index=0&id=0eafbcc4&lang=less&scoped=true"

import exportComponent from "/root/workspace/pt-manage-plugin-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eafbcc4"]])

export default __exports__